<template>
	<div>
		<div class="main">
			<div class="flex">
				<div class="w-full form-group">
					<BaseCheckbox :label="$t('enter_lawyer')" v-model="lawyerDesired" />
				</div>
			</div>
			<div></div>
			<LawyerOfficeForm ref="lawyerForm" v-model="model.lawyerOffice" v-if="isLawyerDesired" :disabled="checkLawyerReferenceNrStored" />
		</div>

		<div class="flex justify-end">
			<SaveButton @click="save" class="mb-4 btn-blue" :disabled="checkLawyerReferenceNrStored">{{ $t('general.save') }}</SaveButton>
		</div>
	</div>
</template>

<script>
import { DamagecasesApiFactory, LawyerofficesApiFactory } from '@/api/generated';
import apiDefaults from '@/api/defaultConfiguration';
import stateMerge from 'vue-object-merge';
import { makeShadowCopy } from '@/plugins/Utils';
import LawyerOfficeForm from '@/components/damagecases/forms/LawyerOfficeForm';
import Authentication from '@/mixins/Authentication';
import { PdfApiFactory } from '@/api/generated';
import { PDFTypes } from '@/api/generated/models';
import BaseCheckbox from '@/components/forms/inputs/BaseCheckbox';
import Validate from '@/mixins/Validate';
import AppContainerMixin from '@/mixins/AppContainerMixin';
import ProcessLog from '@/mixins/damagecase/ProcessLog';
import SaveButton from '@/components/forms/buttons/SaveButton';

export default {
	name: 'LawyerOffice',
	components: { SaveButton, BaseCheckbox, LawyerOfficeForm },
	mixins: [Authentication, Validate, AppContainerMixin, ProcessLog],
	data() {
		return {
			lawyerDesired: true,
			isExternSign: false,
			model: {
				city: {
					zipCode: '',
					name: null,
				},
				lawyerOffice: {
					id: null,
				},
				_shadow: {
					lawyerOffice: {
						id: null,
					},
				},
			},
			signLocation: this.$store.getters.getUser.person.company.city.name,
			sign: null,
			pdfURL: '',
		};
	},
	computed: {
		checkLawyerReferenceNrStored() {
			return this.$store.getters.getDamageCase.lawyerOfficeReferenceNumber != null;
		},
		getPdfType() {
			return PDFTypes.LawyerMandate + '?lawyer_id=' + this.lawyer_id;
		},
		isLawyerDesired() {
			return this.lawyerDesired;
		},
		defaultCity: function() {
			return this.$store.getters.getUser.person.company.city.name;
		},
		lawyer_id() {
			return this.model.lawyerOffice?.id;
		},
	},
	methods: {
		updateDamageCaseStore() {
			this.$store.dispatch('forceUpdateDamageCase', { id: parseInt(this.$route.params.processId || this.$route.params.id) });
		},
		getDamageCaseFromApi: function() {
			this.$store.dispatch('updateDamageCase', { id: parseInt(this.$route.params.processId || this.$route.params.id) }).then(() => {
				const shadowCase = makeShadowCopy(this.$store.getters.getDamageCase);
				stateMerge(this.model, shadowCase);
				this.lawyerDesired = this.model.lawyerOffice !== undefined;
				this.model = makeShadowCopy(this.model);
				this.lawyerDesired = this.model.lawyerOffice != null;
			});
		},
		save() {
			if (this.isExternSign && !this.signLocation) {
				this.$swal(this.$t('general.attention').toString(), this.$t('enter_sign_location').toString(), 'warning');
				return false;
			}

			if (this.lawyerDesired === false) {
				this.removeLawyerOfficeFromDamagecase().then(this.updateDamageCaseStore);
			} else {
				const isFremdanwalt = this.model.lawyerOffice?.isEditable === true;

				if (!isFremdanwalt && this.model.lawyerOffice.id === null) {
					this.$swal(this.$t('general.attention').toString(), this.$t('save_lawyer_or_deactivate').toString(), 'warning');
				} else {
					// Fremdanwalt
					if (isFremdanwalt) {
						if (this.$refs.lawyerForm.validate()) {
							if (this.model.lawyerOffice.id) {
								this.updateDamagecase(false).then(result => {
									this.updateLawyerOffice().then(result2 => {
										this.savePDFtoDamageCase();
										this.$store.commit('setConfirmLeaving', false);
									});
								});
							} else {
								this.updateDamagecase(false).then(result => {
									this.reportProcessChange(this.$route.params.processId || this.$route.params.id);
									this.$swal({
										title: this.$t('general.success').toString(),
										text: this.$t('lawyers_office_data_saved').toString(),
										icon: 'success',
									}).then(result => {
										this.updateDamageCaseStore();
										this.$store.commit('setConfirmLeaving', false);
										this.$router.push({
											name: 'management.process.edit',
											params: { processId: this.$store.getters.getDamageCase.id, customer: this.$store.getters.getDamageCase.customer.id },
										});
									});
								});
							}
						} else {
							this.$swal(this.$t('general.attention').toString(), this.$t('please_check_input').toString(), 'warning');
						}
					} else {
						// Systemanwalt
						this.updateDamagecase(true)
							.then(this.updateDamageCaseStore)
							.then(_ => {
								this.savePDFtoDamageCase();
								this.$store.commit('setConfirmLeaving', false);
							});
					}
				}
			}
		},
		savePDFtoDamageCase(showSuccess) {
			if (this.signLocation && this.showSignField) {
				this.model.signLocation = this.signLocation;
				PdfApiFactory(apiDefaults.config(), apiDefaults.basePath, apiDefaults.axios)
					.pdfDamagecasesTypeSavePost(PDFTypes.LawyerMandate, {
						...this.model,
						lawyerSign: this.sign,
					})
					.then(res => {
						this.$store.dispatch('updateDocuments', { id: this.$route.params.processId || this.$route.params.id });
						if (showSuccess) {
							this.reportProcessChange(this.$route.params.processId || this.$route.params.id);
							this.$swal({
								title: this.$t('general.success').toString(),
								text: this.$t('attorney_saved').toString(),
								icon: 'success',
							}).then(result => {
								this.$store.commit('setConfirmLeaving', false);
								this.$router.push({
									name: 'management.process.edit',
									params: { processId: this.$store.getters.getDamageCase.id, customer: this.$store.getters.getDamageCase.customer.id },
								});
							});
						}
					});
			} else if (!this.model.lawyerOffice?.has_mandante) {
				PdfApiFactory(apiDefaults.config(), apiDefaults.basePath, apiDefaults.axios)
					.pdfDamagecasesIdRemoveTypeDelete(this.$route.params.processId || this.$route.params.id, 'vollmacht-anwalt')
					.then(res => {
						this.$store.dispatch('updateDocuments', { id: this.$route.params.processId || this.$route.params.id });
					});
			}
		},
		removeLawyerOfficeFromDamagecase() {
			return DamagecasesApiFactory(apiDefaults.config(), apiDefaults.basePath, apiDefaults.axios)
				.damagecasesIdLawyerOfficeRemovePut(parseInt(this.$route.params.processId || this.$route.params.id))
				.then(response => {
					this.reportProcessChange(this.$route.params.processId || this.$route.params.id);
					this.$swal({
						title: this.$t('general.success').toString(),
						text: this.$t('no_lawyer_in_damage_case').toString(),
						icon: 'success',
					}).then(result => {
						this.$store.commit('setConfirmLeaving', false);
						this.$router.push({
							name: 'management.process.edit',
							params: { processId: this.$store.getters.getDamageCase.id, customer: this.$store.getters.getDamageCase.customer.id },
						});
					});
				})
				.catch(error => {
					this.$swal(this.$t('general.attention').toString(), this.$t('please_check_input').toString(), 'warning');
				});
		},
		updateLawyerOffice() {
			return LawyerofficesApiFactory(apiDefaults.config(), apiDefaults.basePath, apiDefaults.axios)
				.lawyerofficesIdPut(this.model.lawyerOffice.id, this.model.lawyerOffice)
				.then(response => {
					this.reportProcessChange(this.$route.params.processId || this.$route.params.id);
					this.$swal({
						title: this.$t('general.success').toString(),
						text: this.$t('company_updated').toString(),
						icon: 'success',
					}).then(result => {
						this.$store.commit('setConfirmLeaving', false);
						this.updateDamageCaseStore();
						this.$router.push({
							name: 'management.process.edit',
							params: { processId: this.$store.getters.getDamageCase.id, customer: this.$store.getters.getDamageCase.customer.id },
						});
					});
				})
				.catch(error => {
					this.$swal(this.$t('general.attention').toString(), this.$t('please_check_input').toString(), 'warning');
				});
		},
		createLawyerOffice() {
			return LawyerofficesApiFactory(apiDefaults.config(), apiDefaults.basePath, apiDefaults.axios)
				.lawyerofficesPost(this.model.lawyerOffice)
				.then(response => {
					this.reportProcessChange(this.$route.params.processId || this.$route.params.id);
					this.$swal({
						title: this.$t('general.success').toString(),
						text: this.$t('lawyers_office_data_saved').toString(),
						icon: 'success',
					}).then(result => {
						this.updateDamageCaseStore();
						this.$router.push({
							name: 'management.process.edit',
							params: { processId: this.$store.getters.getDamageCase.id, customer: this.$store.getters.getDamageCase.customer.id },
						});
					});
				})
				.catch(error => {
					this.$swal(this.$t('general.attention').toString(), this.$t('please_check_input').toString(), 'warning');
				});
		},
		updateDamagecase(showMessageBox) {
			return DamagecasesApiFactory(apiDefaults.config(), apiDefaults.basePath, apiDefaults.axios)
				.damagecasesIdLawyerOfficePut(parseInt(this.$route.params.processId || this.$route.params.id), this.model.lawyerOffice)
				.then(response => {
					if (showMessageBox) {
						this.reportProcessChange(this.$route.params.processId || this.$route.params.id);
						this.$swal({
							title: this.$t('general.success').toString(),
							text: this.$t('assign_lawyers_office_damage_case').toString(),
							icon: 'success',
						}).then(result => {
							this.$store.commit('setConfirmLeaving', false);
							this.$router.push({
								name: 'management.process.edit',
								params: { processId: this.$store.getters.getDamageCase.id, customer: this.$store.getters.getDamageCase.customer.id },
							});
						});
					}
				})
				.catch(error => {
					this.$swal(this.$t('general.attention').toString(), this.$t('please_check_input').toString(), 'warning');
				});
		},
		getPDF() {
			this.model.signLocation = this.signLocation;
			this.pdfURL = '';
			PdfApiFactory(apiDefaults.config(), apiDefaults.basePath, apiDefaults.axios)
				.pdfDamagecasesTypeTempSavePost(PDFTypes.LawyerMandate, {
					...this.model,
					lawyerSign: this.sign,
				})
				.then(res => {
					this.pdfURL = apiDefaults.axios.defaults.baseURL + 'api/pdf/damagecases/' + res.data.uuid + '/temp/file#toolbar=0&navpanes=0&scrollbar=0';
				});
		},
	},
	mounted() {
		this.getDamageCaseFromApi();
		this.$store.dispatch('updateDocuments', { id: this.$route.params.processId || this.$route.params.id });
	},
	watch: {
		sign: function() {
			this.getPDF();
		},
		showSignField: function() {
			if (this.showSignField) {
				this.getPDF();
			}
		},
		lawyer_id: function() {
			if (this.showSignField) {
				this.getPDF();
			}
		},
	},
};
</script>

<style scoped></style>
